<template>
  <div v-if="body_show">
    <div class="project_main" v-if="score!=''">
      <router-link class="aac" :to="'/project_report?cid='+ cid + '&cpid=' + pid">
        <img src="@a/score_img.png" class="tb" />
        <h2>{{name+project_doned}}</h2>
        <span>>>></span>
      </router-link>
    </div>
    <div class="project_main" :class="{pvc: score == ''}">
      <h2>项目详情</h2>
      <p class="pj_pb" :class="{pj_hidden: (project.introduce.length>156) && pj_show}" v-html="project.introduce"></p>
      <a class="close_pj" v-show="project.introduce.length>156 && pj_show" @click="pj_show=false"></a>
    </div>
    <div class="project_main pjv">
      <h2>项目学习<span>(请按照以下顺序完成自我探索）</span></h2>
      <ul class="pro_ul">
        <li v-for="(item,index) in project_list" :key="index" class="clearfix">
          <div class="pro_ull clearfix">
            <!-- 类型 1测评 2课程音频 3任务 4讨论小组 -->
            <span>{{item.type==1?'E':item.type==2?'L':item.type==3?'T':item.type==4?'G':''}}</span>
            <div class="pro_ullr">
              <h3>{{item.name}}</h3>
              <h4 v-if="data.project_type==1">{{item.compelteNum}}人 完成</h4>
              <h4 v-else>{{item.groupCompelteNum}}/{{data.totalcount}}人 已完成</h4>
            </div>
          </div>
          <!-- 类型 1测评 2课程音频 3任务 4讨论小组 -->
          <div v-if="item.type==1">
            <a :href="item.skip" class="a" v-if="item.status==0">去测评</a>
            <a :href="item.skip" class="a over" v-else>已完成</a>
          </div>
          <div v-if="item.type==2">
            <router-link class="a over" v-if="item.status == 1" :to="{
                path: '/course_content',
                query: {
                  'id': item.table_id,
                  'cid': cid,
                  'cpid': pid,
                  'pdk': routArg.pdk,
                  'aspx': routArg.aspx,
                  'source': routArg.source
                }
              }">重学</router-link>
            <router-link class="a" v-else :to="{
                path: '/course_content',
                query: {
                  'id': item.table_id,
                  'cid': cid,
                  'cpid': pid,
                  'pdk': routArg.pdk,
                  'aspx': routArg.aspx,
                  'source': routArg.source
                }
              }">{{data.project_type==1?'试学':'去上课'}}</router-link>
          </div>
          <div v-else-if="item.type==3">
            <router-link :to="item.skip + '?cid=' + cid + '&pid=' + pid + '&id=' + item.table_id + '&name=' + project.name" class="a" v-if="item.status==0">做任务</router-link>
            <!-- 判读是否是试学 -->
            <router-link :to="item.skip + '?cid=' + cid + '&pid=' + pid + '&id=' + item.table_id + '&name=' + project.name" class="a over" v-else-if="item.status!=0 && data.project_type==1">重做</router-link>
            <router-link :to="item.skip + '?cid=' + cid + '&pid=' + pid + '&id=' + item.table_id + '&name=' + project.name" class="a over" v-else>已完成</router-link>
          </div>
          <div v-if="item.type==4">
            <router-link class="a over" v-if="item.status == 1" :to="{
                path: '/discuss',
                query: {
                  'table_id': item.table_id
                }
              }">已完成</router-link>
            <router-link class="a" v-else :to="{
                path: '/discuss',
                query: {
                  'table_id': item.table_id
                }
              }">去讨论</router-link>
          </div>
        </li>
      </ul>
    </div>
    <div class="project_main" v-if="tools.faq || tools.href || tools.valuation || tools.selfcheck || (cid>1 && tools.glossary)">
      <h2>项目工具箱</h2>
      <ul class="zil_ul clearfix">
        <li v-if="tools.faq">
          <router-link :to=" '/faq_list?cpid=' + pid + '&cid=' + cid ">
            <img src="@a/zil00.png" />
            <p>项目攻略</p>
          </router-link>
        </li>
        <li v-if="tools.href">
          <router-link :to=" '/further_reading?cpid=' + pid + '&cid=' + cid ">
            <img src="@a/zil11.png" />
            <p>扩展阅读</p>
          </router-link>
        </li>
        <li v-if="tools.valuation">
          <router-link :to=" 'valuation?cpid=' + pid + '&cid=' + cid ">
            <img src="@a/zil22.png" />
            <p>大神导师团</p>
          </router-link>
        </li>
        <li v-if="tools.selfcheck">
          <router-link :to="'check_content?id=' + data.checklistid + '&cid=' + cid ">
            <img src="@a/zil33.png" />
            <p>自查清单</p>
          </router-link>
        </li>
        <li v-if="cid>1 && tools.glossary">
          <router-link :to=" 'difficult_words?cpid=' + pid + '&cid=' + cid ">
            <img src="@a/zil44.png" />
            <p>难词表</p>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="project_main" v-if="data.project_type != 1">
      <h2>
        项目作业
        <span class="all-homework">(可点击学员头像去批改作业)</span>
      </h2>
      <ul class="member_ul clearfix">
        <li v-if="group.length>0" v-for="(item,index) in group" :key="index" @click="toProjectReport(item.uid)">
          <img :src="item.headimgurl" />
          <p>{{item.nickname}}</p>
          <span class="on" v-if="item.complete">完成</span>
        </li>
      </ul>
    </div>
    <!-- 弹框 -->
    <!-- 自己 -->
    <van-popup class="radius" :close-on-click-overlay="true" v-model="showModul">
      <div class="pop pr">
        <img src="@a/task-3-pop.png" alt="" />
        <p class="tips pa">嘿！ {{userDetail.name}}</p>
      </div>
    </van-popup>
    <!-- 公用音频底部 -->
    <public-foot-audio :footerShow="footer_show"></public-foot-audio>
    <!-- 引入卡片弹窗 -->
    <public-pop :imgUrl="data.sharebuy_placard" :cid="cid" :text_assistant="'长按添加助理<br/>领取更多'" :insert_text="'课程资料'" :text_card="'长按保存分享，每入学1位您可获得80元奖学金'" :type="3">
    </public-pop>
  </div>
</template>
<script>
import {
  projectdetail
} from "@/api/assistant";

import {
  getProject
} from "@/api/course2";

import {
  statistics
} from "@/api/public";
import {
  shareCon
} from "@/utils/wxconfig";
import {
  queryString
} from "@/utils/tools";
export default {
  data() {
      return {
        cid: "",
        pid: "",
        data: {},
        body_show: false,
        score: '',
        name: "",
        project_doned: "",
        project: {},
        pj_show: true,
        task: [],
        subject: [],
        groupmember: [],
        footer_show: true,
        replycount: 0,
        userDetail: {},
        showModul: false,
        routArg: {},
        group: [],
        project_list: [],
        // 项目工具箱
        tools:{}
      }
    },
    props: {
      pulldata: Object
    },
    methods: {
      projectList() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let querys = this.$route.query;
        getProject({
            cid: this.$route.query.cid,
            cpid: this.$route.query.cpid,
            pdk: this.$route.query.pdk ? this.$route.query.pdk : '',
            aspx: this.$route.query.aspx ? this.$route.query.aspx : "",
          })
          .then((data) => {
            this.$toast.clear();
            this.body_show = true;
            this.project_list = data.list;
          })
      },
      pullData(data) {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        projectdetail({
            cid: this.$route.query.cid,
            cpid: this.$route.query.cpid
          })
          .then((data) => {
            if (typeof data === "string") {
              let index = data.lastIndexOf('/');
              let x = data.substring(index);
              this.$router.push(x);
              return;
            };

            document.title = data.project.name;
            this.projectList();
            this.body_show = true;
            this.$toast.clear();
            this.data = data;
            this.score = data.score;
            this.name = data.project.name;
            this.project_doned = data.project_doned_status;
            this.cid = data.cid;
            this.pid = data.pid;
            this.project = data.project;
            this.task = data.task;
            this.subject = data.subject;
            this.groupmember = data.groupmember;
            this.group = data.group;
            this.replycount = data.replycount;
            this.userDetail = data.user_detail;
            // 项目工具箱
        this.tools = data.tools;
            this.cacheUserConfig = {
              pdk: data.pdk,
              aspx: data.aspx
            };
            shareCon("course", this);
            let querys = this.$route.query;
            if (querys.source) {
              this.routArg['source'] = querys.source;
            }
            if (querys.pdk) {
              this.routArg['pdk'] = querys.pdk;
            }
            if (querys.aspx) {
              this.routArg['aspx'] = querys.aspx;
            }
          })

      },
      statistical_l() {
        statistics({
          type: "lefticon"
        }).then(data => {
          this.$router.push({
            path: '/index',
            query: {
              'pdk': this.routArg.pdk,
              'aspx': this.routArg.aspx,
              'source': this.routArg.source,
            }
          });
        });
      },
      // 截取返回link中的地址中的路由名称
      url_substying(url_) {
        let index = url_.lastIndexOf('/');
        let last = url_.lastIndexOf('.');
        if (index < 0 || last < 0) {
          return url_;
        }
        let x = url_.substring(index, last);
        return x
      },
      alerts() {
        this.$toast("任务一、任务二完成之后，自动解锁任务三!");
      },
      onScroll() {
        window.onscroll = (ev) => {
          let t = document.documentElement.scrollTop || document.body.scrollTop;
          let w = 100;
          if (t > w) {
            this.footer_show = false;
          } else {
            this.footer_show = true;
          }
        }
      },
      // 全部作业
      homeWorkHandle() {
        this.$router.push({
          path: '/all_homework', //跳转的路径
          query: { //路由传参时push和query搭配使用 ，作用时传递参数
            cpid: this.$route.query.cpid,
            cid: this.$route.query.cid
          }
        });
      },
      // 跳转报告页面
      toProjectReport(uid_) {
        if(this.$route.query.ctype == true || this.$route.query.ctype == 'true'){
          return
        }
        this.$router.push({
          path: '/ta_project_report',
          query: {
            cid: this.$route.query.cid,
            cpid: this.$route.query.cpid,
            uid: uid_
          }
        });
      },
      showModal() {
        let q = this.$route.query;
        let jsonData = window.localStorage.roject3_main;
        let result = jsonData ? JSON.parse(jsonData) : false;
        if (q.showModul == 'true' && !result.showModul) {
          this.showModul = true;
          window.localStorage.roject3_main = JSON.stringify({
            showModul: true
          });
        }
      }
    },
    created() {
      this.pullData(this.pulldata);
      this.showModal()

    },
    mounted() {
      this.onScroll()
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.text-yellow {
  color: #F57F17;
}

.text-bold {
  font-weight: bold;
}

.men_infortop {
  width: 750px;
  line-height: 1;
  padding: changeRem(.4)+px changeRem(.6)+px;
  color: #EB5032;
  font-size: changeRem(.68)+px;
  text-align: left;
  a {
    display: inline-block;
    width: changeRem(4.8)+px;
    img {
      width: 100%;
    }
  }
}

.project_main {
  padding: 30px;
  width: 100%;
  background: #fff;
  .aac {
    background-size: 100% 100%;
    text-align: right;
    width: 100%;
    height: changeRem(3.16)+px;
    display: block;
    background-image: url(../../../assets/project_details_header.png);
    -webkit-border-radius: changeRem(.16)+px;
    border-radius: changeRem(.16)+px;
    position: relative;
    h2 {
      position: absolute;
      font-size: changeRem(.68)+px;
      color: #FFFFFF;
      top: changeRem(.76)+px;
      left: changeRem(.6)+px;
      font-weight: normal;
      letter-spacing: 1px;
    }
    img {
      width: changeRem(2.96)+px;
      height: changeRem(2.24)+px;
      margin: 0 auto;
      margin-top: changeRem(.6)+px;
      margin-right: changeRem(1.2)+px;
    }
  }
  .message {
    font-size: 24px;
    color: #EB5032;
    padding: 8px 13px;
    border: 1px solid #EB5032;
    margin-left: 24px;
    font-weight: normal;
    cursor: pointer;
  }
  .all-homework {    font-size: 24px;
    color: #EB5032;
    margin-left: 35px;
    font-weight: normal;
    cursor: pointer;
    i {
      vertical-align: middle;
    }
  }
}

.project_main {
  padding: changeRem(.6)+px;
  width: 100%;
  background: #fff;
  margin-top: changeRem(.4)+px;
  h2 {
    font-size: changeRem(.68)+px;
    color: #333;
    line-height: changeRem(.8)+px;
    text-align: left;
    font-weight: bold;
    span {
      color: #EB5032;
      font-size: changeRem(.48)+px;
      vertical-align: middle;
    }
  }
  .pj_pb {
    font-size: changeRem(.52)+px;
    color: #333;
    line-height: changeRem(.8)+px;
    width: 100%;
    text-align: justify;
    margin-top: changeRem(.56)+px;
    height: auto;
  }
  .pj_pb.pj_hidden {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
    overflow: hidden;
    height: changeRem(6)+px;
  }
  .close_pj {
    display: block;
    margin: 0 auto;
    margin-top: changeRem(.4)+px;
    width: changeRem(.88)+px;
    height: changeRem(.6)+px;
    background: url(../../../assets/down_l.png) no-repeat top center;
    background-size: cover;
  }
  .zil_ul {
    margin: 0 auto;
    margin-top: changeRem(1)+px;
    li {
      width: 20%;
      margin-right: 0;
      float: left;
      text-align: center;
      a {
        display: block;
        width: 100%;
        height: 100%;
        img {
          width: 48px;
          height: 48px;
        }
        p {
          font-size: changeRem(.4)+px;
          color: #333;
          line-height: 40px;
          margin-top: 20px
        }
      }
    }
  }
  .member_ul {
    margin-top: changeRem(.8)+px;
    li {
      width: changeRem(1.2)+px;
      margin-right: 0;
      float: left;
      margin-right: changeRem(.5)+px;
      margin-bottom: changeRem(.2)+px;
      text-align: center;
      position: relative;
      img {
        width: changeRem(1.2)+px;
        height: changeRem(1.2)+px;
        border-radius: 50%;
      }
      p {
        font-size: 16px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
      }
      span {
        display: inline-block;
        position: absolute;
        height: 26px;
        line-height: 26px;
        top: -1px;
        right: -50%;
        background-color: #EB5032;
        color: #fff;
        border-radius: 13px;
        font-size: 16px;
      }
      span.on {
        padding: 0px 7px;
        top: -1px;
        right: -16px;
      }
    }
  }
}

.project_main.pvc {
  margin-top: 0;
}

.project_main.pjv {
  padding-bottom: changeRem(.2)+px;
  .pro_ul {
    width: 100%;
    li {
      line-height: changeRem(2.28)+px;
      width: 100%;
      color: #333;
      font-size: changeRem(.52)+px;
      border-bottom: 1px solid #ccc;
      .pro_ull {
        line-height: changeRem(2.28)+px;
        width: changeRem(10)+px;
        color: #333;
        font-size: changeRem(.52)+px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        text-align: justify;
        padding: changeRem(.6)+px 0;
        span {
          color: #EB5032;
          font-size: changeRem(.68)+px;
          line-height: changeRem(1.2)+px;
          float: left;
        }
        .pro_ullr {
          width: changeRem(8.7)+px;
          margin-left: changeRem(.4)+px;
          float: left;
          h3 {
            color: #333;
            font-size: changeRem(.52)+px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            padding: changeRem(.05)+px 0;
            line-height: 1.1
          }
          h4 {
            color: #999;
            font-size: changeRem(.48)+px;
            margin-top: changeRem(.2)+px;
            line-height: 1.1
          }
        }
      }
      .a {
        display: block;
        width: changeRem(2.68)+px;
        height: changeRem(1.08)+px;
        line-height: changeRem(1.08)+px;
        background: rgba(235, 80, 50, 1);
        border-radius: changeRem(.56)+px;
        text-align: center;
        font-size: changeRem(.52)+px;
        color: #fff;
        float: right;
        margin-top: changeRem(.6)+px;
      }
      .a.over {
        background-color: #fff;
        border: 2px solid #EB5032;
        color: #EB5032;
      }
      .a.on {
        background-color: #ccc
      }
    }
    li:last-child {
      border-bottom: none;
    }
  }
  .decult {
    width: changeRem(13.8)+px;
    height: changeRem(4)+px;
    background: rgba(247, 247, 247, 1);
    box-shadow: 0px changeRem(.08)+px changeRem(.16)+px 0px rgba(204, 204, 204, 0.51);
    border-radius: changeRem(.16)+px;
    margin-top: changeRem(.84)+px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: changeRem(.8)+px;
    .decult_t {
      background: #fff;
      text-align: center;
      padding: changeRem(.5)+px 0;
      h3 {
        color: #EB5032;
        font-size: changeRem(.58)+px;
        line-height: changeRem(.8)+px;
        letter-spacing: changeRem(.1)+px;
      }
      h4 {
        color: #666;
        font-size: changeRem(.48)+px;
        line-height: changeRem(.6)+px;
        margin-top: changeRem(.3)+px;
      }
    }
    .a {
      color: #999;
      font-size: changeRem(.4)+px;
      text-align: right;
      float: right;
      margin-right: changeRem(.6)+px;
      line-height: changeRem(1.3)+px;
      width: 100%
    }
  }
}

.pop {
  font-size: 30px;
  width: 8rem;
  .tips {
    left: 80px;
    top: 180px;
    font-size: 0.26rem;
  }
  img {
    max-width: 100%;
  }
}
</style>
